module.exports = __webpack_public_path__ + "static/hacker-84e09c3ed4b46c63b15de0ba19e18841.webm";